import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import Swal from 'sweetalert2';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';

const Formulario = ({ paises, lang }) => {

    const { t } = useTranslation();
    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else if (lang == "pt")
        registerLocale('pt', pt)
    else if (lang == "ru")
        registerLocale('ru', ru)
    else
        registerLocale('es', es)

    const [nombre, setNombre] = useState('');
    const [apellido1, setApellido1] = useState('');
    const [apellido2, setApellido2] = useState('');
    const [telefono, setTelefono] = useState('');
    const [fechanac, setFechanac] = useState(null);
    const [pais, setPais] = useState('');
    const [residencia, setResidencia] = useState('');
    const [dni, setDni] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    const [consentimiento, setConsentimiento] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = "/creasocio";

        var mensajeerror = "";

        if (nombre.trim() === "" || apellido1.trim() === "" || telefono.trim() === "" || fechanac === null || pais.trim() === "" || residencia.trim() === "" || dni.trim() === "" || email.trim() === "" || !consentimiento) {
            if (nombre.trim() === "") mensajeerror += `${t("Nombre")}<br/>`;
            if (apellido1.trim() === "") mensajeerror += `${t("Apellido")}<br/>`;
            if (telefono.trim() === "") mensajeerror += `${t('Teléfono')}<br/>`;
            if (fechanac === null) mensajeerror += `${t("Fecha nacimiento")}<br/>`;
            if (pais.trim() === "") mensajeerror += `${t("Nacionalidad")}<br/>`;
            if (residencia.trim() === "") mensajeerror += `${t("Pais de residencia")}<br/>`;
            if (dni.trim() === "") mensajeerror += `${t("Documento")}<br/>`;
            if (email.trim() === "") mensajeerror += `${t('Email')}<br/>`;

            if (password.trim() === "") mensajeerror += `${t('Contraseña')}<br/>`;
            if (password2.trim() === "") mensajeerror += `${t('Contraseña 2')}<br/>`;

            if (password.trim() !== "" && password2.trim() !== "" && password.trim() !== password2.trim()) mensajeerror += `${t('Contraseñas diferentes')}<br/>`;

            if (!consentimiento) mensajeerror += `${t("consentimiento")}<br/>`;

            Swal.fire({
                title: `${t('Error')}`,
                html: `${t('Todos los campos obligatorios')}<br/>` + mensajeerror,
                timer: 2500,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeClick: false
            });
        } else {
            let elnombre = nombre;
            let elapellido1 = apellido1;
            let elapellido2 = apellido2;
            let eltelefono = telefono;
            let lafecha = fechanac;
            let elpais = pais;
            let laresidencia = residencia;
            let eldni = dni;
            let elmail = email;
            let elpassword = password;

            let elidioma = document.getElementById("idioma").value;

            let token = document.getElementById('meta_token').getAttribute('content');
            const result = axios.post(url, {
                elnombre: elnombre,
                elapellido: elapellido1 + " " + elapellido2,
                eltelefono: eltelefono,
                lafecha: lafecha,
                elpais: elpais,
                laresidencia: laresidencia,
                eldni: eldni,
                elmail: elmail,
                lang: elidioma,
                lacontrasenya: elpassword
            }, {
                headers: {
                    'content-type': 'text/json',
                    'X-CSRF-TOKEN': token
                }
            })
                .then((response) => {
                    console.log(response);
                    if (response.data.type === "error") {
                        Swal.fire({
                            title: "KO!",
                            html: `${t('Contacto no enviado')}`,
                            timer: 1500,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        });
                    } else {
                        Swal.fire({
                            title: "OK!",
                            html: `${t('Contacto enviado')}`,
                            timer: 1500,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }
                });
        }
    };


    return (
        <div className="container">
            <h2>
                {t("REGÍSTRATE GRATIS Y")} <span style={{ color: "rgb(150, 113, 38)" }}>{t("GANA TUS PRIMEROS 100 PUNTOS")}</span>
            </h2>

            <div className="container rw-container-big">
                <form noValidate="" className="mb-6 mb-md-100 ng-untouched ng-pristine ng-invalid" onSubmit={handleSubmit}>
                    <input type="hidden" name="lang" id="idioma" value={lang.toString()} />
                    <fieldset className="mb-5 mb-md-5">
                        <legend>{t("DATOS PERSONALES")}</legend>
                        <div className="row small-gutters">
                            <div className="mb-3 col-md-4">
                                <label htmlFor="nombre" className="o-rw-label">Nombre*</label>
                                <input apprestrictchars="" maxLength={30} type="text" name="name" className="form-control o-rw-input ng-untouched ng-pristine ng-invalid" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                            </div>
                            <div className="mb-3 col-md-4">
                                <label htmlFor="primer_apellido" className="o-rw-label">Primer apellido* </label>
                                <input apprestrictchars="" maxLength={30} type="text" id="primer_apellido" name="surname" className="form-control o-rw-input ng-untouched ng-pristine ng-invalid" value={apellido1} onChange={(e) => setApellido1(e.target.value)} />
                            </div>
                            <div className="mb-3 col-md-4">
                                <label htmlFor="segundo_apellido" className="o-rw-label">Segundo apellido </label>
                                <input apprestrictchars="" maxLength={30} type="text" id="segundo_apellido" name="secondSurname" className="form-control o-rw-input ng-untouched ng-pristine ng-invalid" value={apellido2} onChange={(e) => setApellido2(e.target.value)} />
                            </div>
                            <div className="mb-3 col-sm-6 col-md-4">

                                <div className="w-100">
                                    <label className="o-rw-label">Teléfono*</label>
                                    <input maxLength={30} id="telf" name="phone" onChange={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }} data-qm-block="true" className="form-control o-rw-input ng-untouched ng-pristine ng-invalid" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                </div>

                            </div>
                            <div className="mb-3 col-sm-6 col-md-4">
                                <div className="form-input">
                                    <label htmlFor="fecha" className="o-rw-label">Fecha de nacimiento*</label>

                                    <app-date-mask-input>
                                        <DatePicker
                                            isClearable={true}
                                            monthsShown={1}
                                            selected={fechanac}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText={t("DD/MM/YYYY")}
                                            locale={lang}
                                            name="fecha"
                                            id="fecha"
                                            showMonthDropdown
                                            showYearDropdown
                                            className="form-control cpointer noborder fs1"
                                            autoComplete="off"
                                            onChange={(date) => {
                                                console.log(date);
                                                setFechanac(date);
                                            }}
                                        >
                                        </DatePicker>
                                    </app-date-mask-input>
                                </div>
                            </div>
                            <div className="mb-3 col-sm-6 col-md-4">
                                <label htmlFor="telf" className="o-rw-label">Nacionalidad*</label>
                                <select className="form-select o-rw-select ng-untouched ng-pristine ng-valid" required name="country" id="country" value={pais} onChange={(e) => setPais(e.target.value)} >
                                    <option value="">{t("Pais").toUpperCase()}</option>
                                    {paises.map((unpais, index) => {
                                        return (
                                            <option value={unpais.id} key={index}>{unpais.nombre.toUpperCase()}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="mb-3 col-sm-6 col-md-4">
                                <label htmlFor="telf" className="o-rw-label">País de residencia*</label>
                                <select className="form-select o-rw-select ng-untouched ng-pristine ng-valid" required name="country" id="countryResidence" value={residencia} onChange={(e) => setResidencia(e.target.value)}>
                                    <option value="">{t("Pais").toUpperCase()}</option>
                                    {paises.map((unpais, index) => {
                                        return (
                                            <option value={unpais.id} key={index}>{unpais.nombre.toUpperCase()}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="mb-3 col-sm-6 col-md-4">
                                <label className="o-rw-label">{t("Tipo de documento")}</label>
                                <select id="pay_doctype" name="pay_doctype" name="documentType" data-qm-block="true" className="form-select o-rw-select ng-untouched ng-pristine ng-valid">
                                    <option value="0: 1">{t("DNI")}</option>
                                </select>
                            </div>
                            <div className="col-sm-6 col-md-4">
                                <label className="o-rw-label">{t("Número de documento")}"*</label>
                                <input type="text" onChange={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9-/]/g, ''); setDni(e.target.value); }} name="document" maxLength={16} data-qm-block="true" className="form-control ng-untouched ng-pristine ng-invalid" value={dni} />
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="mb-4 mb-md-5">
                        <legend>{t("DATOS DE ACCESO")}</legend>
                        <div className="row align-items-end">
                            <div className="mb-3 col-md-6 col-lg-4">
                                <label className="form-label">E-mail*</label>
                                <input type="text" name="email" maxLength={60} onChange={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, ''); setEmail(e.target.value) }} data-qm-encrypt="true" className="form-control ng-untouched ng-pristine ng-invalid" value={email} />
                            </div>
                            <div className="mb-3 col-md-6 col-lg-4">
                                <label className="form-label">{t("Contraseña")}*</label>
                                <input type="password" name="email" maxLength={60} onChange={(e) => { setPassword(e.target.value) }} data-qm-encrypt="true" className="form-control ng-untouched ng-pristine ng-invalid" value={password} />
                            </div>
                            <div className="mb-3 col-md-6 col-lg-4">
                                <label className="form-label">{t("Repite contraseña")}*</label>
                                <input type="password" name="email" maxLength={60} onChange={(e) => { setPassword2(e.target.value) }} data-qm-encrypt="true" className="form-control ng-untouched ng-pristine ng-invalid" value={password2} />
                            </div>
                        </div>
                    </fieldset>
                    <div className="gap-4 row c-rw-registro_submit gap-md-0">
                        <div className="col-md-5">
                            <div className="form-check o-rw-check form-check-start">
                                <input type="checkbox" className="form-check-input ng-untouched ng-pristine ng-invalid" checked={consentimiento} onChange={(e) => setConsentimiento(e.target.checked)} />
                                <label className="form-check-label">
                                    <p>{t("He leído y acepto las")} <a href={`/${preidioma}${t("condiciones-rewards")}`} rel="noopener noreferrer" target="_blank"> {t("condiciones generales del programa Vale Rewards")}</a> y la <a href={`/${preidioma}${t("politica-de-privacidad")}`} rel="noopener noreferrer" target="_blank">
                                        <u>{t("política de protección de datos")}.</u>
                                    </a>
                                    </p>
                                </label>
                            </div>

                        </div>
                        <div className="col-md-7 col-lg-6">
                            <button type="submit" className="mx-auto text-sm btn rw-btn btn-rewards mx-md-0 d-flex d-md-block">{t("ENVIAR")}</button>
                        </div>
                    </div>
                    <p className="pt-3 mt-3 text-xxs text-gray">

                        <strong>{t("Responsable:")}</strong>VALE SUITES, S.L. <strong>{t("Finalidades:")}</strong> {t("Gestionar el alta, mantenimiento y participación en el Programa, gestionar la obtención y redención de puntos y otros beneficios asociados a la condición de Socio, atender solicitudes de información y gestión de incidencias y gestionar el envío de comunicaciones comerciales. Legitimación: Ejecución de la relación contractual y el consentimiento del interesado.")} <strong>{t("Destinatarios:")}</strong> {t("Vale Suites. No se cederán datos a terceros, salvo obligación legal.")} <strong>{t("Derechos:")}</strong> {t("Puede ejercer sus derechos de acceso, rectificación, supresión, oposición y, en su caso, portabilidad y limitación, enviando un escrito a la siguiente dirección:  o por correo electrónico a")} <a href="mailto:#" rel="noopener noreferrer" target="_blank">
                            <u>xxx@valesuites.com</u>

                        </a>. {t("Puede consultar información adicional sobre Protección de Datos en nuestra")} <a href={`/${preidioma}${t("politica-de-privacidad")}`} rel="noopener noreferrer" target="_blank">
                            <u>{t("Política de Privacidad.")}</u>
                        </a>
                    </p>
                </form>
            </div>


        </div>
    )
}

export default Formulario;
